import * as THREE from "three";
import { VIEW_HEIGHT } from "./constants";
import { WallMapData } from "./wallBake";

export * from "./wallBake";

export interface WallMaps {
  normalMap: THREE.DataTexture | null;
  colorMap: THREE.DataTexture | null;
}

function makeDataTexture(data: Uint8Array, sizeX: number, sizeY: number, srgb: boolean): THREE.DataTexture {
  const tex = new THREE.DataTexture(data, sizeX, sizeY);
  if (srgb) {
    tex.colorSpace = THREE.SRGBColorSpace;
  }
  tex.wrapS = THREE.RepeatWrapping;
  tex.wrapT = THREE.RepeatWrapping;
  tex.magFilter = THREE.LinearFilter;
  tex.minFilter = THREE.LinearMipmapLinearFilter;
  tex.generateMipmaps = true;
  tex.needsUpdate = true;
  return tex;
}

export function wrapWallMaps(d: WallMapData): WallMaps {
  return {
    normalMap: makeDataTexture(d.normal, d.sizeX, d.sizeY, false),
    colorMap: d.color ? makeDataTexture(d.color, d.sizeX, d.sizeY, true) : null,
  };
}

export function wallWorldRepeat(tiles: number): { x: number; y: number } {
  return { x: VIEW_HEIGHT / tiles, y: VIEW_HEIGHT / tiles };
}
